import React, { useState } from "react";
import { Box, Button, FormControl, FormLabel, Input, VStack, Heading, Text, useToast } from "@chakra-ui/react";

interface RegistrationFormProps {
  onClose: () => void;
}
const Base_apiUrl=process.env.REACT_APP_API_Base_Url;
export default function RegistrationForm({ onClose }: RegistrationFormProps) {
  const [formData, setFormData] = useState({
    username: "",
    password: "",
    phone: "",
    image: null as File | null,
    countryCode: "",
  });
  const [isLoading, setIsLoading] = useState(false);
  const toast = useToast();

  const handleChange = (e: any) => {
    const { name, value, files } = e.target;
    setFormData({
      ...formData,
      [name]: files ? files[0] : value,
    });
  };

  const handleSubmit = async (e: any) => {
    e.preventDefault();
    setIsLoading(true);
    
    try {
      const imageFile = formData.image;
      let base64Image = "";
      
      if (imageFile) {
        base64Image = await new Promise((resolve) => {
          const reader = new FileReader();
          reader.onloadend = () => {
            const base64String = reader.result as string;
            resolve(base64String.split(',')[1]);
          };
          reader.readAsDataURL(imageFile);
        });
      }

      // Create registration data object with the new format
      const registrationData = {
        email: formData.username,
        password: formData.password,
        phoneNo: formData.phone,
        profileImage: base64Image || "string",
        countryCode: formData.countryCode,
        createdDate: new Date().toISOString()
      };
      
      // Updated backend URL
      const apiUrl = `${Base_apiUrl}User/CreateUser`;
      
      const response = await fetch(apiUrl, {
        method: 'POST',
        headers: {
          'Content-Type': 'application/json',
          'Accept': 'application/json'
        },
        body: JSON.stringify(registrationData)
      });

      const data = await response.json();
      console.log("Registration response:", data);

      if (data.statusCode === 1) {
        toast({
          title: 'Success',
          description: data.message || 'Registration successful',
          status: 'success',
          duration: 3000,
          isClosable: true,
        });
        onClose();
      } else {
        toast({
          title: 'Error',
          description: data.message || 'Registration failed',
          status: 'error',
          duration: 3000,
          isClosable: true,
        });
      }
      
    } catch (error) {
      console.error('Registration error:', error);
      toast({
        title: 'Error',
        description: error instanceof Error ? error.message : 'An unexpected error occurred',
        status: 'error',
        duration: 3000,
        isClosable: true,
      });
    } finally {
      setIsLoading(false);
    }
  };

  return (
    <Box
      position="fixed"
      top="50%"
      left="50%"
      transform="translate(-50%, -50%)"
      bg="white"
      p={6}
      borderRadius="md"
      boxShadow="lg"
      zIndex={1000}
      width="400px"
    >
      <Heading size="lg" mb={4}>Registration Form</Heading>
      <form onSubmit={handleSubmit}>
        <VStack spacing={4}>
          <FormControl isRequired>
            <FormLabel>Email:</FormLabel>
            <Input
              type="email"
              name="username"
              value={formData.username}
              onChange={handleChange}
              placeholder="Enter your email"
            />
          </FormControl>

          <FormControl isRequired>
            <FormLabel>Password:</FormLabel>
            <Input
              type="password"
              name="password"
              value={formData.password}
              onChange={handleChange}
              placeholder="Enter your password"
            />
          </FormControl>

          <FormControl isRequired>
            <FormLabel>Phone Number:</FormLabel>
            <Input
              type="tel"
              name="phone"
              value={formData.phone}
              onChange={handleChange}
              placeholder="Enter your phone number"
            />
          </FormControl>

          <FormControl>
            <FormLabel>Profile Image:</FormLabel>
            <Input
              type="file"
              name="image"
              onChange={handleChange}
              accept="image/*"
              p={1}
            />
          </FormControl>

          <FormControl isRequired>
            <FormLabel>Country Code:</FormLabel>
            <Input
              type="text"
              name="countryCode"
              value={formData.countryCode}
              onChange={handleChange}
              placeholder="e.g. +1, +91"
            />
          </FormControl>

          <Button 
            type="submit" 
            colorScheme="blue" 
            width="full"
            isLoading={isLoading}
            loadingText="Registering..."
          >
            Register
          </Button>

          <Button variant="ghost" width="full" onClick={onClose}>
            Back to Login
          </Button>
        </VStack>
      </form>
    </Box>
  );
}
